import { useMemo, useRef, useState } from "react";
import { AttributeDefinition, AttributeInputType, AttributeTargetType, CreateRange } from "../Data/WBData";
import { UpdateStyleFunction } from "../Stylebuilder";
import { AttributeFieldProps } from "./RenderAttributeInput";
import SliderField from "./SliderFeild";
import LayoutNode, { getNodeComponentAttributeValue, getNodeRootStyleAttributeValue, getNodeStyleAttributeValue, setNodeComponentAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { gridAttributes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { ClampAllGridAreaBounds, ConvertGridLayoutToMobile, defualtGridSizing, GetGridRenderData } from "../Utilities/GridUtils";
import { NumInput } from "./GridAreaField";
import XIcon from "vagaro-website-rendering/src/components/Icons/XIcon";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { GetScreensizeIcon } from "../Icons/ScreenSizeIcons";
import GearIcon from "../Icons/GearIcon";
import MeasurementField from "./MeasurementField";

export default function GridField({layoutObject,updateFunc,screenSize,saveFunc,siteData}:AttributeFieldProps){

    const debounceRef = useRef<any>(null);
    const [adjustBothGaps,setAdjustBothGaps] = useState(
        getNodeStyleAttributeValue(layoutObject,screenSize,gridAttributes.gridGapX,"0") == getNodeStyleAttributeValue(layoutObject,screenSize,gridAttributes.gridGapY,"0")
    )



    const  showGridPreview = ()=>{

        let isShowing = getNodeComponentAttributeValue(layoutObject,gridAttributes.forcePreview,"")!="";

        if(!isShowing){
            setNodeComponentAttributeValue(layoutObject,gridAttributes.forcePreview,"true");
            let l = layoutObject as LayoutNode;
            l.forceUpdate && l.forceUpdate();

        }
        if(debounceRef.current){
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(()=>{
            setNodeComponentAttributeValue(layoutObject,gridAttributes.forcePreview,"");
            let l = layoutObject as LayoutNode;
            l.forceUpdate && l.forceUpdate();
        },666);


    }


    const gapXDefinition = useMemo(()=>{

      return  new AttributeDefinition("gridGap","Gap",gridAttributes.gridGapX,AttributeInputType.gridSize,[],CreateRange(0,75,1,"",0),AttributeTargetType.Style);

    },[]);


    const ratioDefinition = useMemo(()=>{

        return new AttributeDefinition("gridRatio","Cell Ratio",gridAttributes.gridRatio,AttributeInputType.gridSize,[
            {label:"Auto",value:""},
            {label:"S",value:".5"},
            {label:"M",value:"1"},
            {label:"L",value:"2"},
        ],CreateRange(.5,2,.05,"",1),AttributeTargetType.Style);
    },[]);



    const gapOverride   : UpdateStyleFunction = (attribute,value,targetType)=>{

        updateFunc(attribute,value,AttributeTargetType.Style);
        showGridPreview();

    }

    const UpdateBothGaps : UpdateStyleFunction = (attribute,value,targetType)=>{
        updateFunc(gridAttributes.gridGapY,value,AttributeTargetType.Style);
        updateFunc(gridAttributes.gridGapX,value,AttributeTargetType.Style);

        showGridPreview();

        if(!adjustBothGaps){
            setAdjustBothGaps(true);
        }
    }

    const updateTemplate   : UpdateStyleFunction = (attribute,value,targetType)=>{
        if(value!=""){
                  value = `repeat(${value}, 1fr)`
        }

        ClampAllGridAreaBounds(layoutObject as LayoutNode);
        updateFunc(attribute,value,AttributeTargetType.Style);
        showGridPreview();

    }

    let data = GetGridRenderData(layoutObject as LayoutNode,screenSize);

    let colStr = getNodeStyleAttributeValue(layoutObject,screenSize,gridAttributes.gridTemplateColumns,"");
    let rowStr = getNodeStyleAttributeValue(layoutObject,screenSize,gridAttributes.gridTemplateRows,"");


    return (
        <div
        className="wb-input-group no-border"
        onPointerMove={()=>{showGridPreview();}}
        >
        <div className="flex-row w-full gap-med justify-center" >
        <div className="w-full">
            <label>Columns</label>
            <NumInput debounce={true} key={screenSize+"col"} placeHolder={data.colCount.toString()}  autoVal={data.colCount} min={1} max={64} inVlaue={colStr? data.colCount.toString():""} onUpdate={(num)=>{updateTemplate(gridAttributes.gridTemplateColumns,num.toString(),AttributeTargetType.Style)}}/>
            </div>
        <div className="center-all" style={{paddingTop:"30px",width:"100px"}}><XIcon/></div>
            <div className="w-full">
            <label >Rows</label>
            <NumInput  debounce={true}  key={screenSize+"row"} placeHolder={data.rowCount.toString()} autoVal={data.rowCount} clsAdd="row-count-input" min={1} max={1000} inVlaue={rowStr? data.rowCount.toString():""} onUpdate={(num)=>{updateTemplate(gridAttributes.gridTemplateRows,num.toString(),AttributeTargetType.Style)}}/>
            </div>
        </div>

            <div className="flex-row align-start">
                <div className="flex-column w-full ">
                    <div className="w-full no-border">
                    <SliderField allowAuto={true} label={ "Grid Gap" } definition={gapXDefinition} layoutObject={layoutObject} updateFunc={UpdateBothGaps} screenSize={screenSize} saveFunc={saveFunc} siteData={siteData} />
                    </div>

                </div>

                <div className="wb-input-row" style={{display:"block",width:"auto",margin:"54px 0 0 8px"}}>
                <button style={{width:"40px"}} className={"invisible-button  rounded-button  "+(!adjustBothGaps?"selected":"") }

                        onClick={() => {
                            setAdjustBothGaps(!adjustBothGaps);

                        }}
                    ><GearIcon /></button>
                    </div>
            </div>
            <div className="flex-row gap-med " style={{transition:".2s",overflow:"hidden",maxHeight:!adjustBothGaps?"100px":"0px",minHeight:!adjustBothGaps?"80px":"0px"}}>
            {!adjustBothGaps &&<>

                            <div className="w-full">
                                <label >Horizontal</label>
                                <NumInput debounce={false} placeHolder="" autoVal={data.gapY} min={0} max={75} inVlaue={getNodeStyleAttributeValue(layoutObject, screenSize, gridAttributes.gridGapX, "0")} onUpdate={(num) => {

                                    gapOverride(gridAttributes.gridGapX, num.toString(), AttributeTargetType.Style);

                                }} />
                            </div>
                            <div className="w-full"> <label >Vertical</label>
                                <NumInput debounce={false} placeHolder="" autoVal={data.gapY} min={0} max={75} inVlaue={getNodeStyleAttributeValue(layoutObject, screenSize, gridAttributes.gridGapY, "0")} onUpdate={(num) => {
                                    gapOverride(gridAttributes.gridGapY, num.toString(), AttributeTargetType.Style);
                                }} />
                            </div>

                            </> }
                    </div>
<hr style={{marginBottom:"-6px"}}/>
        <MeasurementField  label={"Cell Height"} definition={ratioDefinition} layoutObject={layoutObject} updateFunc={gapOverride} screenSize={screenSize} saveFunc={saveFunc} siteData={siteData} isFourWay={false}/>

        <hr />
            {screenSize != ScreenSize.Desktop &&<div className="flex-column w-full gap-med">
                <button className="w-button w-button-secondary w-full center-all gap-med" style={{ marginTop: "16px" }} onClick={() => {
                    setNodeStyleAttributeValue(layoutObject, screenSize, gridAttributes.gridTemplateColumns, "");
                    setNodeStyleAttributeValue(layoutObject, screenSize, gridAttributes.gridTemplateRows, "");
                    setNodeStyleAttributeValue(layoutObject, screenSize, gridAttributes.gridGapX, "");
                    setNodeStyleAttributeValue(layoutObject, screenSize, gridAttributes.gridGapY, "");
                    let node = layoutObject as LayoutNode;
                    for (let i = 0; i < node.children.length; i++) {
                        let child = node.children[i];
                        setNodeStyleAttributeValue(child, screenSize, gridAttributes.gridArea, "");
                    }
                    node.forceUpdate && node.forceUpdate();
                    saveFunc();


                }}>Clear Layout <GetScreensizeIcon screenSize={screenSize}/></button>



                <button className="w-button w-button-secondary w-full center-all gap-med"  onClick={() => {

                    let col = getNodeRootStyleAttributeValue(layoutObject,screenSize,gridAttributes.gridTemplateColumns,"");
                    let row = getNodeRootStyleAttributeValue(layoutObject,screenSize,gridAttributes.gridTemplateRows,"");
                    let gridGapX = getNodeRootStyleAttributeValue(layoutObject,screenSize,gridAttributes.gridGapX,"");
                    let gridGapY = getNodeRootStyleAttributeValue(layoutObject,screenSize,gridAttributes.gridGapY,"");


                    setNodeStyleAttributeValue(layoutObject, screenSize -1, gridAttributes.gridTemplateColumns, col);
                    setNodeStyleAttributeValue(layoutObject, screenSize -1, gridAttributes.gridTemplateRows, row);
                    setNodeStyleAttributeValue(layoutObject, screenSize -1, gridAttributes.gridGapX, gridGapX);
                    setNodeStyleAttributeValue(layoutObject, screenSize -1, gridAttributes.gridGapY, gridGapY);
                    let node = layoutObject as LayoutNode;

                    for (let i = 0; i < node.children.length; i++) {
                        let child = node.children[i];
                        let area = getNodeRootStyleAttributeValue(child,screenSize,gridAttributes.gridArea,"");
                        setNodeStyleAttributeValue(child, screenSize-1, gridAttributes.gridArea, area);
                    }
                    node.forceUpdate && node.forceUpdate();
                    saveFunc();

                    siteData.designer&&siteData.designer.setState({ screenSize: screenSize - 1 });


                }}>Apply Layout to  <GetScreensizeIcon screenSize={screenSize - 1} /></button>



                </div>
            }

            {/* {   <button className="w-button w-button-secondary w-full center-all gap-med" style={{ marginTop: "10px" }}
             onClick={() => {
                ConvertGridLayoutToMobile(layoutObject as LayoutNode,screenSize);
                saveFunc();

                let mobileBtn = document.querySelector(".mobile.preview-option");
                if (mobileBtn) {
                    (mobileBtn as any).click();
                    setTimeout(() => {

                        let dom = document.getElementById(layoutObject.id);
                        if(dom){
                            dom.scrollIntoView({ behavior: "smooth", block: "center" });
                        }
                    },100)

                }


             }} >Generate Mobile Layout</button>

            } */}

        </div>
    )








}